"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusOptions = exports.rowsPerPageOptions = exports.meterTypeOptions = exports.meterLevelOptions = exports.METER_PURPOSE_LABELS = exports.METER_PURPOSE_COLOURS = exports.columns = void 0;
var statusOptions = [
    { key: "all", label: "All" },
    { key: "active", label: "Active" },
    { key: "inactive", label: "Inactive" },
];
exports.statusOptions = statusOptions;
var meterTypeOptions = [
    { key: "all", label: "All Types" },
    { key: "Power", label: "Power" },
    { key: "Water", label: "Water" },
];
exports.meterTypeOptions = meterTypeOptions;
var meterLevelOptions = [
    { key: "all", label: "All Levels" },
    { key: "area", label: "Area Level" },
    { key: "building", label: "Building Level" },
];
exports.meterLevelOptions = meterLevelOptions;
var rowsPerPageOptions = [
    { key: "5", label: "5" },
    { key: "10", label: "10" },
    { key: "25", label: "25" },
    { key: "50", label: "50" },
    { key: "100", label: "100" },
];
exports.rowsPerPageOptions = rowsPerPageOptions;
var columns = [
    { name: "METER ID", uid: "meterId" },
    { name: "TYPE", uid: "meterType" },
    { name: "SERIAL NUMBER", uid: "serialNumber" },
    { name: "BUILDING", uid: "buildingName" },
    /*
     * MC&LCC-3.2. Erik asked for the purpose "between the building and area name", and for the area
     * column to be renamed: one column answering "what is this meter attached to", whichever kind of
     * thing that turns out to be — an area, a service, or a named check meter.
     */
    { name: "METER PURPOSE", uid: "meterPurpose" },
    { name: "METER DESIGNATION", uid: "meterDesignation" },
    { name: "TENANT", uid: "tenantName" },
    { name: "RESPONSIBLE PARTY", uid: "responsibleParty" },
    { name: "MAKE / MODEL", uid: "meterMakeModel" },
    { name: "KVA RATING", uid: "kvaRating" },
    { name: "READING TYPE", uid: "isManualReading" },
    { name: "STATUS", uid: "isActive" },
    { name: "ACTIONS", uid: "actions" },
];
exports.columns = columns;
/*
 * One place for how a purpose reads, because it is now shown in two: the summary tiles and the table
 * column. They were a ternary each, which is how two labels for the same thing start to disagree.
 */
var METER_PURPOSE_LABELS = {
    CONSUMPTION: "Consumption",
    PRODUCTION_BULK: "Production/Bulk",
    CHECK: "Check",
};
exports.METER_PURPOSE_LABELS = METER_PURPOSE_LABELS;
var METER_PURPOSE_COLOURS = {
    CONSUMPTION: "primary",
    PRODUCTION_BULK: "secondary",
    CHECK: "warning",
};
exports.METER_PURPOSE_COLOURS = METER_PURPOSE_COLOURS;
